import { render, staticRenderFns } from "./VacancyIndex.vue?vue&type=template&id=b81bba0e&scoped=true&"
import script from "./VacancyIndex.vue?vue&type=script&lang=js&"
export * from "./VacancyIndex.vue?vue&type=script&lang=js&"
import style0 from "./VacancyIndex.vue?vue&type=style&index=0&id=b81bba0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81bba0e",
  null
  
)

export default component.exports